// icons.ts
import {
    heroMagnifyingGlass,
    heroPaperAirplane,
    heroArrowUturnLeft,
    heroChatBubbleLeftRight,
    heroFaceSmile,
    heroPaperClip,
    heroXMark,
    heroTrash,
    heroArchiveBox,
    heroDocument,
    heroDocumentText,
    heroMusicalNote,
    heroPhoto,
    heroTableCells,
    heroVideoCamera,
    heroArrowDownTray,
    heroArrowLeft,
    heroClipboard,
    heroPencil,
    heroUserPlus,
    heroUsers,
    heroSparkles,
    heroChatBubbleLeftEllipsis,
    heroEllipsisVertical,
    heroEllipsisHorizontal,
    heroChevronDown,
    heroChevronUp,
    heroNoSymbol,
    heroPause,
    heroPlay,
    heroMagnifyingGlassPlus,
    heroEnvelope,
    heroArrowUpRight,
    heroCheckCircle
} from '@ng-icons/heroicons/outline';
import { tablerChecks, tablerCheck } from '@ng-icons/tabler-icons';
export const APP_ICONS = {
    heroMagnifyingGlass,
    heroPaperAirplane,
    heroArrowUturnLeft,
    heroChatBubbleLeftRight,
    heroFaceSmile,
    heroPaperClip,
    heroXMark,
    heroTrash,
    heroArchiveBox,
    heroDocument,
    heroDocumentText,
    heroMusicalNote,
    heroPhoto,
    heroTableCells,
    heroVideoCamera,
    heroArrowDownTray,
    heroArrowLeft,
    heroClipboard,
    heroPencil,
    heroUserPlus,
    heroUsers,
    heroSparkles,
    heroChatBubbleLeftEllipsis,
    heroEllipsisVertical,
    heroEllipsisHorizontal,
    heroChevronDown,
    heroChevronUp,
    heroNoSymbol,
    heroPause,
    heroPlay,
    heroMagnifyingGlassPlus,
    tablerCheck,
    tablerChecks,
    heroEnvelope,
    heroArrowUpRight,
    heroCheckCircle
};
